<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
                <v-card>
                    <v-card-title>
                        <span v-t="'admin.inviraRole.editing'"></span>
                        <v-spacer></v-spacer>
                        <v-btn @click="goBack" icon>
                            <v-icon>arrow_back</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <loading v-if="loadingRole || loadingPermissions"></loading>
                        <div v-else>
                            <Invira-roles-form 
                                ref="form" 
                                v-model="form" 
                                :input-errors="inputErrors" 
                                :permissions="permissions" 
                                :roles="roles"
                                class="mt-3"
                            ></Invira-roles-form>

                            <v-row class="mt-3">
                                <v-col cols="12" class="text-right">
                                    <v-btn @click="goBack" class="mr-2">
                                        {{ $t('common.cancel') }}
                                    </v-btn>
                                    <v-btn color="primary" @click="save" :loading="saving" :disabled="isAdminRole">
                                        {{ $t('common.save') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <snackbar v-model="flash"/>
    </v-container>
</template>

<script>
    import InviraRoleProvider from "../../../providers/InviraRoleProvider";
    import { Loading, Snackbar } from '@dracul/common-frontend'
    import { ClientError } from "../../../../../errors";
    import InviraRolesForm from '../InviraRolesForm'

    export default {
        name: "InviraRolesPermissions",
        components: {InviraRolesForm, Loading, Snackbar},
        data() {
            return {
                loadingRole: true,
                loadingPermissions: true,
                saving: false,
                errorMessage: "",
                inputErrors: {},
                role: null,
                roles: [],
                permissions: [],
                flash: null,
                form: {
                    id: null,
                    name: '',
                    childRoles: [],
                    permissions: []
                }
            };
        },
        computed: {
            isAdminRole() {
                const name = (this.role && this.role.name) || (this.form && this.form.name) || "";
                return String(name).toLowerCase() === "admin";
            }
        },
        created() {
            this.loadRole();
            this.loadPermissions();
        },
        methods: {
            loadRole() {
                const roleId = this.$route.params.roleId;
                if (!roleId) {
                    this.goBack();
                    return;
                }
                
                this.loadingRole = true;
                InviraRoleProvider.findRole(roleId)
                    .then(r => {
                        if (r && r.data && r.data.adminInviraRoleFind) {
                            this.role = r.data.adminInviraRoleFind;
                            this.form = {
                                id: this.role.id,
                                name: this.role.name,
                                childRoles: this.role.childRoles ? (Array.isArray(this.role.childRoles) ? this.role.childRoles.map(r => (typeof r === 'object' ? r.id : r)) : []) : [],
                                permissions: this.role.permissions ? (Array.isArray(this.role.permissions) ? [...this.role.permissions] : []) : []
                            };
                        } else {
                            this.goBack();
                        }
                    })
                    .catch(err => {
                        console.error('Error loading role:', err);
                        this.goBack();
                    })
                    .finally(() => {
                        this.loadingRole = false;
                    });
            },
            loadPermissions() {
                // Load all roles to extract permissions
                InviraRoleProvider.fetchRoles()
                    .then(r => {
                        const allRoles = r.data.adminInviraRoleFetch || [];
                        this.roles = allRoles;
                        
                        // Extract all unique permissions from all roles
                        const allPermissions = new Set();
                        allRoles.forEach(role => {
                            if (role.permissions && Array.isArray(role.permissions)) {
                                role.permissions.forEach(perm => allPermissions.add(perm));
                            }
                        });
                        this.permissions = Array.from(allPermissions).sort();
                    })
                    .catch(err => {
                        console.error('Error loading permissions:', err);
                    })
                    .finally(() => {
                        this.loadingPermissions = false;
                    });
            },
            save() {
                if (this.$refs.form.validate()) {
                    this.saving = true
                    InviraRoleProvider.roleUpdate(this.form)
                        .then(r => {
                            if (r) {
                                this.flash = this.$t('admin.inviraRole.updated')
                                this.$router.push('/Invira-roles-management');
                            }
                        })
                        .catch(error => {
                            let clientError = new ClientError(error);
                            this.inputErrors = clientError.inputErrors
                            this.errorMessage = clientError.i18nMessage
                        }).finally(() => this.saving = false)
                }
            },
            goBack() {
                this.$router.push('/Invira-roles-management');
            }
        }
    };
</script>

<style scoped>
</style>

